import { render, staticRenderFns } from "./ImportNewData.vue?vue&type=template&id=76b8da32&scoped=true&"
import script from "./ImportNewData.vue?vue&type=script&lang=js&"
export * from "./ImportNewData.vue?vue&type=script&lang=js&"
import style0 from "./ImportNewData.vue?vue&type=style&index=0&id=76b8da32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8da32",
  null
  
)

export default component.exports